import Vue from 'vue'
import App from './App.vue'

// Plugins
import router from './router'
import store from './store'

// Styling
import '@/views/project-synthecite/styles/main.scss'

// librarys
import Vue2TouchEvents from 'vue2-touch-events'
import AOS from 'aos'
import 'aos/dist/aos.css'

// FA
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSteam, faTwitch, faTwitter, faInstagram, faRedditAlien } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSteam)
library.add(faTwitch)
library.add(faTwitter)
library.add(faInstagram)
library.add(faRedditAlien)

Vue.config.productionTip = false

Vue.component('fa-icon', FontAwesomeIcon)
Vue.use(Vue2TouchEvents)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    AOS.init({
      disable: 'mobile'
    })
  }
}).$mount('#app')
